import { render, staticRenderFns } from "./helpForm.vue?vue&type=template&id=5769cdda&"
import script from "./helpForm.vue?vue&type=script&lang=ts&"
export * from "./helpForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports